export default __webpack_public_path__ + "static/media/fig-03-weak-zone-filled.6918da27.png";